import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { defaultRouteForUser, hasPageAccess } from '../lib/pageAccess';

export default function RoleGuard({ children, roles, page }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  // Keep the requested page (and its query) so a shared deep link survives sign-in.
  if (!user) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultRouteForUser(user)} replace />;
  }
  if (page && !hasPageAccess(user.custom_pages, page)) {
    return <Navigate to={defaultRouteForUser(user)} replace />;
  }
  return children;
}
